import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["competenciesSection", "expressFieldsContainer"]

  connect() {
    // Initial state - check if express profile is enabled
    // Use setTimeout to ensure DOM is fully loaded
    setTimeout(() => {
      this.updateVisibility()
    }, 100)
  }

  toggle(event) {
    const isChecked = event.target.checked
    console.log('Express Profile toggle:', isChecked)
    this.updateVisibility(isChecked)
  }

  updateVisibility(isExpressProfile = null) {
    // If no parameter provided, check the current state
    if (isExpressProfile === null) {
      // Search in element first, then in document
      const checkbox = this.element.querySelector('input[name="profile[express_profile]"]') || 
                       document.querySelector('input[name="profile[express_profile]"]')
      isExpressProfile = checkbox ? checkbox.checked : false
    }

    console.log('Update visibility:', isExpressProfile)
    console.log('Has competencies section target:', this.hasCompetenciesSectionTarget)
    console.log('Has express fields container target:', this.hasExpressFieldsContainerTarget)

    if (isExpressProfile) {
      // Hide competencies section
      if (this.hasCompetenciesSectionTarget) {
        this.competenciesSectionTarget.style.display = 'none'
        console.log('Hidden competencies section')
      }
      
      // Add express fields dynamically
      this.addExpressFields()
    } else {
      // Show competencies section
      if (this.hasCompetenciesSectionTarget) {
        this.competenciesSectionTarget.style.display = 'block'
        console.log('Shown competencies section')
      }
      
      // Remove express fields
      this.removeExpressFields()
    }
  }

  addExpressFields() {
    if (this.hasExpressFieldsContainerTarget && !this.expressFieldsContainerTarget.querySelector('.express-profile-fields')) {
      const expressFieldsHTML = `
        <div class="express-profile-fields bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-6 border border-purple-200 shadow-sm">
          <div class="flex items-center mb-4">
            <div class="flex-shrink-0 w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
              <i class="fas fa-briefcase text-purple-600 text-lg"></i>
            </div>
            <div>
              <h3 class="text-lg font-semibold text-gray-900">Managementprofil</h3>
              <p class="text-sm text-gray-600">Spezielle Felder für Führungskräfte und Management-Positionen</p>
            </div>
          </div>
          
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <!-- Key Projects -->
            <div>
              <label for="profile_key_projects" class="block text-sm font-medium text-gray-700 mb-2">Schlüsselprojekte</label>
              <textarea name="profile[key_projects]" id="profile_key_projects" class="tw-form-control min-h-[150px]" placeholder="Beschreiben Sie die wichtigsten Projekte, die Sie geleitet haben..."></textarea>
              <p class="mt-1 text-xs text-gray-500">
                Listen Sie Ihre wichtigsten Projekte und deren Auswirkungen auf.
              </p>
            </div>
            
            <!-- Expertise -->
            <div>
              <label for="profile_expertise" class="block text-sm font-medium text-gray-700 mb-2">Expertise</label>
              <textarea name="profile[expertise]" id="profile_expertise" class="tw-form-control min-h-[150px]" placeholder="Beschreiben Sie Ihre fachlichen Schwerpunkte und Kompetenzen..."></textarea>
              <p class="mt-1 text-xs text-gray-500">
                Ihre fachlichen Schwerpunkte und besonderen Kompetenzen.
              </p>
            </div>
            
            <!-- Industry Expertise -->
            <div class="lg:col-span-2">
              <label for="profile_industry_expertise" class="block text-sm font-medium text-gray-700 mb-2">Branchenexpertise</label>
              <textarea name="profile[industry_expertise]" id="profile_industry_expertise" class="tw-form-control min-h-[120px]" placeholder="Beschreiben Sie Ihre Branchenerfahrung und -kenntnisse..."></textarea>
              <p class="mt-1 text-xs text-gray-500">
                Ihre Erfahrung in verschiedenen Branchen und Märkten.
              </p>
            </div>
          </div>
        </div>
      `
      
      this.expressFieldsContainerTarget.innerHTML = expressFieldsHTML
      console.log('Express Profile fields added to DOM')
    }
  }


  removeExpressFields() {
    if (this.hasExpressFieldsContainerTarget) {
      this.expressFieldsContainerTarget.innerHTML = ''
    }
  }
}
